import { env } from '@/constant';
import { RightsPay } from '@hb/rights-pay';

const HBridge = import('@hb/hbridge');

export const RightsPayInstance = RightsPay({
  env,
  ubt: window.TianQi.UBT,
  hbridge: HBridge,
});
